"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var zenObservable_1 = require("./zenObservable");
tslib_1.__exportStar(require("./zenObservable"), exports);
exports.default = zenObservable_1.Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/zen-observable-ts/lib/index.js
// module id = 321
// module chunks = 0